import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classnames from 'classnames';
import t from '../../../lib/I18n';

import ToggleInputSimple from '../../form/ToggleInputSimple';
import HelpIcon from '../../general/HelpIcon';
import FeatureFlag from "../../general/FeatureFlag";

export default function CheckedOption({
    onChange,
    enableEmailMarketing,
    enableSmsMarketing,
    emailField,
    smsField,
    emailChecked,
    smsChecked,
    text,
    disabled,
    helpModalText,
    hideSmsField,
    helpIconFeatureFlag,
    isHalfOnState,
    isEmailProducts,
    southeasternId,
    emailTestId,
    smsTestId,
}) {

    const handleToggle = field => () => {
        onChange(field, field === emailField ? !emailChecked : !smsChecked);
    };

    const textClass = classnames({ "text-light": disabled });

    const infoId = isEmailProducts
        ? t('new-products-and-services-updates')
        : t('promotions-and-reward-updates');

    return (
        <Fragment>
            <li className="checked-option__row">
                {enableEmailMarketing && (
                    <div className="checked-option__cell">
                        <ToggleInputSimple className="marketing-preference__checkbox"
                            id={ emailField }
                            label={ emailField }
                            labelClassName="sr-only"
                            onChange={ handleToggle(emailField) }
                            checked={ emailChecked }
                            disabled={ disabled }
                            isHalfOnState={ isHalfOnState }
                            titleId= { isEmailProducts ? t('') : t('') }
                            infoId= { infoId }
                            southeasternId={ southeasternId }
                            testId={ emailTestId }
                        />
                    </div>
                )}

                {enableSmsMarketing && (
                    <div className="checked-option__cell">
                        {!hideSmsField && (
                            <ToggleInputSimple className="marketing-preference__checkbox"
                                id={ smsField }
                                label={ smsField }
                                labelClassName="sr-only"
                                onChange={ handleToggle(smsField) }
                                checked={ smsChecked }
                                disabled={ disabled }
                                testId={ smsTestId }
                            />
                        )}
                    </div>
                )}

                <div className={classnames('checked-option__label', textClass)}>
                    {text}
                    <FeatureFlag name={ helpIconFeatureFlag }>
                        {helpModalText && <HelpIcon message={helpModalText} centerMessage/>}
                    </FeatureFlag>
                </div>
            </li>
            {isHalfOnState && (
                <div className="checked-option__info" id={infoId}>
                    {isEmailProducts
                        ? t('preference-centre.toggle.info.emailProducts')
                        : t('preference-centre.toggle.info.emailPromotions')}
                </div>
            )}
        </Fragment>
    );
}

CheckedOption.propTypes = {
    enableEmailMarketing: PropTypes.bool,
    emailField: PropTypes.string,
    enableSmsMarketing: PropTypes.bool,
    smsField: PropTypes.string,
    text: PropTypes.string,
    onChange: PropTypes.func,
    emailChecked: PropTypes.bool,
    smsChecked: PropTypes.bool,
    disabled: PropTypes.bool,
    helpModalText: PropTypes.string,
    hideSmsField: PropTypes.bool,
    helpIconFeatureFlag: PropTypes.string,
    isHalfOnState: PropTypes.bool,
    isEmailProducts: PropTypes.bool,
    southeasternId: PropTypes.string,
    emailTestId: PropTypes.string,
    smsTestId: PropTypes.string,
};

CheckedOption.defaultProps = {
    enableEmailMarketing: false,
    emailField: '',
    enableSmsMarketing: false,
    smsField: '',
    text: '',
    onChange: _.noop,
    emailChecked: false,
    smsChecked: false,
    disabled: false,
    helpModalText: '',
    hideSmsField: false,
    helpIconFeatureFlag: '',
};
